"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryInfo = getCountryInfo;
exports.getCountryStateOptions = getCountryStateOptions;
exports.allCountriesOptions = void 0;

var _countries = _interopRequireDefault(require("./countries"));

var _usaStates = _interopRequireDefault(require("./usa-states"));

var _caStates = _interopRequireDefault(require("./ca-states"));

var _auStates = _interopRequireDefault(require("./states/au-states"));

var _ptStates = _interopRequireDefault(require("./states/pt-states"));

var _gbStates = _interopRequireDefault(require("./states/gb-states"));

var _ieStates = _interopRequireDefault(require("./states/ie-states"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const mappedStatesByCountryCode = {
  ca: _caStates.default,
  us: _usaStates.default,
  au: _auStates.default,
  pt: _ptStates.default,
  gb: _gbStates.default,
  ie: _ieStates.default
};

function getStatesByCountry(countryCode) {
  return mappedStatesByCountryCode[countryCode];
}

function normalizedCountryCode(code) {
  return code.toLowerCase();
}

function getCountryDefinitionByCode(code) {
  return _countries.default.find(c => normalizedCountryCode(c.code) === normalizedCountryCode(code));
}

function extractCountryCodesList(countryCodes) {
  const getAll = Array.isArray(countryCodes) && !countryCodes.length;
  let countries = [];

  if (getAll) {
    countries = _countries.default.map(({
      code
    }) => code);
  } else {
    countries = Array.isArray(countryCodes) ? countryCodes : [countryCodes];
  }

  return countries.map(c => normalizedCountryCode(c));
}

function makeStateOptionsFromList(statesList) {
  return statesList.map(state => ({
    optLabel: state.name,
    optValue: state.code
  }));
}

function getCountryStateOptions(countryCodes = []) {
  const countries = extractCountryCodesList(countryCodes);

  if (countries.length === 1) {
    const countryStates = mappedStatesByCountryCode[countries[0]];

    if (!countryStates) {
      return;
    }

    return makeStateOptionsFromList(countryStates);
  }

  return countries.reduce((acc, country) => {
    const {
      name
    } = getCountryDefinitionByCode(country);
    const countryStates = mappedStatesByCountryCode[country];

    if (countryStates && name) {
      acc.push({
        optGroupLabel: name,
        options: makeStateOptionsFromList(countryStates)
      });
    }

    return acc;
  }, []);
}

const allCountriesOptions = _countries.default.map(c => ({
  optLabel: c.name,
  optValue: c.code
}));

exports.allCountriesOptions = allCountriesOptions;

function getCountryInfo(countryCodes = [], includeStates = false) {
  const countries = extractCountryCodesList(countryCodes);
  return countries.reduce((acc, country) => {
    const countryDefinition = getCountryDefinitionByCode(country);

    if (countryDefinition) {
      acc[country] = { ...countryDefinition
      };

      if (includeStates) {
        acc[country].states = mappedStatesByCountryCode[country] || [];
      }
    }

    return acc;
  }, {});
}